export default __webpack_public_path__ + "static/media/J270_RoHS.c1067dbc.pdf";